import { render, staticRenderFns } from "./FiltersAccordion.vue?vue&type=template&id=cf55bf68&scoped=true&"
import script from "./FiltersAccordion.vue?vue&type=script&lang=js&"
export * from "./FiltersAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FiltersAccordion.vue?vue&type=style&index=0&id=cf55bf68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf55bf68",
  null
  
)

export default component.exports